import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import YourShare from './your-share';
import YourShareMinContribution from './your-share.min-contribution';
import YourSharePricingDetails from './your-share.pricing-details';
import MultiCurrencyNotice from '../../../containers/multi-currency-notice.container';

import Purchase from '../../../lib/purchase';
import money  from '../../../lib/money';

class SummaryShareContribute extends Component {
  constructor(props) {
    super(props);
    this.onCommit = this.onCommit.bind(this);
  }

  onCommit() {
    this.props.onCommit();
  }

  disableContributions() {
    return this.props.disabled;
  }

  contributeButtonText() {
    const { full, completed } = this.props;
    if (full || completed) {
      return (
        <FormattedMessage
          id="summaryShare.contributeButton.groupIsFull"
          defaultMessage="The group is full"
        />
      );
    }

    return <FormattedMessage
      id="summaryShare.contributeButton.contribute"
      defaultMessage="Contribute"
    />;
  }

  showWithPricingDetails() {
    return this.props.costRange.length > 1;
  }

  renderCurrentShare() {
    const {
      completed,
      costRange,
      costType,
      splitType,
      membership,
      currentProductCostAmount,
      minContribution
    } = this.props;

    if (completed) return null;
    if (!membership) return null;

    const { fees: { consumerFee }, shareAmount, claimedSlots, amount } = membership;
    const costPerSlot = Purchase.isFixedPerPerson(splitType) ? currentProductCostAmount : null;
    const props = {
      amount,
      shareAmount,
      feesAmount: consumerFee,
      costPerSlot,
      claimedSlots,
      costType,
      splitType,
    };

    if (minContribution && !money(minContribution).isZero()) {
      return <YourShareMinContribution {...props} />;
    }

    if (this.showWithPricingDetails()) {
      return (
        <YourSharePricingDetails
          {...props}
          costRange={costRange}
        />
      );
    }

    return <YourShare {...props} />;
  }

  renderYourShareBox() {
    const { membership } = this.props;
    if (!membership) return null;
    const shareAmount = money(membership.shareAmount);
    const minContribution = money(this.props.minContribution);
    const noShareAmount = !shareAmount || shareAmount.isZero();
    const noMinContribution = !minContribution || minContribution.isZero();

    if (noShareAmount && noMinContribution) return;

    return (
      <div>
        {this.renderCurrentShare()}
        <MultiCurrencyNotice />
      </div>
    );
  }

  render() {
    return (
      <div className="summary-share-contribute yourshare-block">
        <div className="yourshare-box">
          <hr />
          <div className="contribute text-center">
            {this.renderYourShareBox()}
            <button
              type="button"
              onClick={this.onCommit}
              className="btn btn-primary btn-block"
              disabled={this.disableContributions()}
            >
              {this.contributeButtonText()}
            </button>
          </div>
          <div className="small-print container">
            <p className="mt-3 mb-0 text-center">
              <FormattedMessage
                id="summaryShare.disclaimer"
                defaultMessage="You won't be charged until enough group members commit to fund the full purchase amount."
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

SummaryShareContribute.defaultProps = {
  onCommit: () => {},
};

export default SummaryShareContribute;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/group-summary/summary-share.contribute.js